import * as React from 'react';
import { ICapacite } from '../../../models';
import { StatusBadge } from '../../shared/StatusBadge';
import styles from './CapacityTable.module.scss';

export interface ICapacityTableProps {
  capacites: ICapacite[];
}

export const CapacityTable: React.FC<ICapacityTableProps> = ({ capacites }) => {
  const depotGroups = React.useMemo(() => {
    const groups: Record<string, ICapacite[]> = {};
    capacites.forEach(c => {
      if (!groups[c.Depot]) groups[c.Depot] = [];
      groups[c.Depot].push(c);
    });
    return groups;
  }, [capacites]);

  return (
    <div className={styles.wrapper}>
      <div className={styles.tableTitle}>Détail des allocations</div>
      <table className={styles.table}>
        <thead>
          <tr>
            <th>Dépôt</th>
            <th>Bac</th>
            <th>Produit</th>
            <th>Volume alloué (m³)</th>
            <th>% du bac</th>
            <th>Contrat</th>
            <th>Statut</th>
          </tr>
        </thead>
        <tbody>
          {Object.entries(depotGroups).map(([depotName, items]) => (
            <React.Fragment key={depotName}>
              <tr className={styles.depotGroupRow}>
                <td colSpan={7}>{depotName}</td>
              </tr>
              {items.map((c, i) => (
                <tr key={`${c.DepotId}-${c.BacId}-${c.Produit}`} className={styles.dataRow} style={{ animationDelay: `${i * 0.03}s` }}>
                  <td className={styles.cellDepot}>{c.Depot}</td>
                  <td className={styles.cellBac}>{c.Bac}</td>
                  <td><StatusBadge contenu={c.Produit} compact /></td>
                  <td className={styles.cellVolume}>{c.VolumeAlloue.toLocaleString('fr-FR')}</td>
                  <td className={styles.cellPct}>{Math.round(c.PctBac * 100)}%</td>
                  <td className={styles.cellContrat}>
                    <span className={
                      c.TypeContrat === 'Long terme' ? styles.contratLong :
                      c.TypeContrat === 'Annuel' ? styles.contratAnnuel :
                      styles.contratSpot
                    }>
                      {c.TypeContrat}
                    </span>
                  </td>
                  <td>
                    <span className={styles.statutActif}>{c.Statut}</span>
                  </td>
                </tr>
              ))}
            </React.Fragment>
          ))}
        </tbody>
      </table>
    </div>
  );
};
